import type { FC } from 'react';
import React, { memo, Fragment } from 'react';

import { GeneralShortcutListener } from '@confluence/shortcuts/entry-points/GeneralShortcutListener.ts';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';

export type KeyboardShortcutWrapperProps = {
	href?: string;
	keyboardShortcut?: string | string[];
	deprecatedKeyboardShortcut?: string | string[];
	isAppNavigationShortcut?: boolean;
	onShortcutTriggered: Function;
	children?: React.ReactNode;
};

export const KeyboardShortcutWrapper: FC<KeyboardShortcutWrapperProps> = memo(
	({
		href,
		keyboardShortcut,
		deprecatedKeyboardShortcut,
		isAppNavigationShortcut,
		children,
		onShortcutTriggered,
	}) => {
		const { push } = useRouteActions();

		const listenerCallback = () => {
			onShortcutTriggered();
			href && push(href);
		};

		return (
			<Fragment>
				{children}
				{keyboardShortcut && (
					<GeneralShortcutListener
						deprecatedAccelerator={deprecatedKeyboardShortcut}
						accelerator={keyboardShortcut}
						listener={listenerCallback}
						isAppNavigationShortcut={isAppNavigationShortcut || false}
					/>
				)}
			</Fragment>
		);
	},
);
